
import React, { Component } from "react";
import AppHeader from "../AppHeader";
import AppLeftSideBar from "../AppLeftSideBar";
import { AppLayout } from "../Layout";
import Backdrop from '../Backdrop';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import * as navigationActions from '../../../redux/actions/navigationActions';


class DashboardLayout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showLeftSideBar: false
        }
        this.props.actions.updateHamburgerMenuStatus(false);
    }
    onClickToggleLeftSideBar = (e) => {
        if (window.innerWidth <= 1024) {
            this.setState({
                showLeftSideBar: !this.state.showLeftSideBar
            })

        } else {
            this.setState({
                showLeftSideBar: !this.state.showLeftSideBar
            })
        }
        // this function fires when clicking anywhere on the leftSideBar, including hamburger menu icon
        this.props.actions.updateHamburgerMenuStatus(true);
    }

    onClickToggleRightSideBar = (e) => {
        if (window.innerWidth <= 1024) {
            this.setState({
                showLeftSideBar: false
            });
        }
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerWidth });
        if (window.innerWidth <= 500) {

            this.setState({
                showLeftSideBar: false
            })
        }
    }

    componentDidMount = () => {
        window.addEventListener("resize", this.updateDimensions);
        this.updateDimensions();
    }


    componentWillUnmount = () => {
        window.removeEventListener("resize", this.updateDimensions);
    }


    render() {
        // console.log('** hamburgerMenu **:', this.props.hamburgerMenu); // debug
        const { showLeftSideBar } = this.state;
        const { updateHamburgerMenuStatus } = this.props.actions;
        // delay reset of hamburgerMenu status to allow page redirect to complete
        setTimeout(function () {
            if (!showLeftSideBar) {
                updateHamburgerMenuStatus(false);
            }
        }, 1000);

        return (
            <React.Fragment>

                <AppLayout header={<AppHeader onClickToggleLeftSideBar={this.onClickToggleLeftSideBar} />}
                    showLeftSideBar={this.state.showLeftSideBar}
                    leftSideBar={<AppLeftSideBar onClickToggleLeftSideBar={this.onClickToggleLeftSideBar} />}>
                    {this.props.children}
                    {this.state.showLeftSideBar && <Backdrop />}
                </AppLayout>
            </React.Fragment>
        );
    }
}


DashboardLayout.propTypes = {
    hamburgerMenu: PropTypes.bool.isRequired,
  };

  function mapStateToProps(state) {
    return {
        hamburgerMenu: state.navigation.hamburgerMenu,
    }
  }

  function mapDispatchToProps(dispatch) {
    return {
      actions: {
        updateHamburgerMenuStatus: bindActionCreators(
          navigationActions.updateHamburgerMenuStatus,
          dispatch
        )
      }
    };
  }

  export default connect(
    mapStateToProps,
    mapDispatchToProps,
  )(DashboardLayout);



// WEBPACK FOOTER //
// ./src/Components/Theme/DashboardLayout/index.js